<script setup lang="ts">
import { register, type SwiperContainer } from 'swiper/element/bundle'
import { ref, computed } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'

register()

const props = defineProps<{
	pageContent: PageContent
}>()

const swiperEl = ref<SwiperContainer | null>(null)
const currentSlideIndex = ref(0)

const prevSlide = () => {
	if (swiperEl.value) {
		swiperEl.value.swiper.slidePrev()
	}
}

const nextSlide = () => {
	if (swiperEl.value) {
		swiperEl.value.swiper.slideNext()
	}
}

const handleSlideChange = (event: any) => {
	currentSlideIndex.value = event.detail[0].realIndex
}

const validUpgradeItems = computed(() => {
	return props.pageContent.upgrade.filter(
		item => item.title && item.title.trim() !== '',
	)
})
</script>

<template>
	<div class="bs-container">
		<div class="col-span-12">
			<div class="relative">
				<swiper-container
					ref="swiperEl"
					:loop="validUpgradeItems.length > 1"
					slides-per-view="1"
					class="w-full"
					@swiperslidechange="handleSlideChange"
				>
					<swiper-slide
						v-for="(upgradeItem, index) in validUpgradeItems"
						:key="index"
					>
						<div class="flex w-full flex-col gap-[20px] mdp:flex-row">
							<div class="flex items-center justify-center mdp:flex-1">
								<img
									:src="upgradeItem.img"
									:alt="`image upgrade ${upgradeItem.title}`"
									class="object-cover"
									loading="lazy"
								/>
							</div>
							<div
								class="flex flex-col mdp:flex-1 mdl:p-[32px_32px_0_32px] lg:pl-[48px]"
							>
								<div
									class="typography-h3-str mb-casual-friends text-center mdp:text-start"
								>
									{{ upgradeItem.title }}
								</div>
								<div
									v-for="step in upgradeItem.steps"
									:key="step.title"
									class="mb-acquaintances flex flex-col gap-close-friends last:mb-0"
								>
									<div class="flex items-center gap-[12px]">
										<div class="inline-block rounded-lg bg-o-75 p-[8px]">
											<BaseIcon
												:name="step.icon"
												class="h-24px w-24px fill-o-500"
											/>
										</div>
										<div class="typography-s1-emp text-o-500">
											{{ step.title }}
										</div>
									</div>
									<div v-html="step.description" />
								</div>
							</div>
						</div>
					</swiper-slide>
				</swiper-container>

				<!-- Left arrow - only show from step 2 onwards -->
				<BaseIcon
					v-if="validUpgradeItems.length > 1 && currentSlideIndex > 0"
					name="chevron_round"
					class="absolute left-0 top-1/2 z-[1] h-[40px] w-[40px] -translate-y-1/2 rotate-180 cursor-pointer"
					@click="prevSlide"
				/>

				<!-- Right arrow - only show until second last step -->
				<BaseIcon
					v-if="
						validUpgradeItems.length > 1 &&
						currentSlideIndex < validUpgradeItems.length - 1
					"
					name="chevron_round"
					class="absolute right-0 top-1/2 z-[1] h-[40px] w-[40px] -translate-y-1/2 cursor-pointer"
					@click="nextSlide"
				/>
			</div>
		</div>
	</div>
</template>
